import {
  blueCup,
  comboSet2,
  comboSet3,
  comboSet4,
  donutPlate,
  fancyBowls,
  fancyCup,
  jugPlanter,
  whiteBrownPlanter,
  whiteGoldPlate,
  woodenBowl,
} from "../../assets";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: "6ba388d3-e662-4a56-9d47-cfdab4788299",
    title: "Fancy Cup With Gold",
    price: {
      discounted: 4500,
      original: 6750,
    },
    rating: 5,
    imgURL: fancyCup,
    categoryGroup: "Dining",
    categoryName: "Cups",
    offer: "50%",
    isBestseller: false,
  },
  {
    _id: "0bed5f7a-285e-4fc4-ad8a-2191576ebe02",
    title: "White Jug Planter",
    price: {
      discounted: 299,
      original: 999,
    },
    rating: 1,
    imgURL: jugPlanter,
    categoryName: "Planters",
    categoryGroup: ["Decor", "Gifts"],
    offer: "70%",
    isBestseller: false,
  },
  {
    _id: "8s7079e3-5467-4012-9d58-596887022259",
    title: "Self Design Bowls",
    price: {
      discounted: 3599,
      original: 5000,
    },
    rating: 5,
    imgURL: fancyBowls,
    categoryName: "Bowls",
    categoryGroup: ["Dining"],
    offer: "combo-offer",
    isBestseller: true,
  },
  {
    _id: "483aae0d-c2ff-499d-9ab4-4bjs622e610d",
    title: "Simple Cappuccino Cup",
    price: {
      discounted: 479,
      original: 1599,
    },
    rating: 1,
    imgURL: blueCup,
    categoryGroup: ["Dining"],
    categoryName: "Cups",
    offer: "70%",
    isBestseller: true,
  },
  {
    _id: "319d3e92-47a3-49f3-9c89-d10d0668e5e2",
    title: "Micheil Set of 7 Plates",
    price: {
      discounted: 4000,
      original: 7500,
    },
    rating: 4,
    imgURL: comboSet3,
    categoryGroup: ["Dining", "Gifts"],
    categoryName: "Plates",
    offer: "combo-offer",
    isBestseller: true,
  },
  {
    _id: "eec0dfda-a573-4f98-8c39-b5fb1fe21fec",
    title: "Valiant Set of 6 Plates",
    price: {
      discounted: 5000,
      original: 8000,
    },
    rating: 3,
    imgURL: comboSet4,
    categoryGroup: ["Kitchen", "Gifts"],
    categoryName: "Plates",
    offer: "combo-offer",
    isBestseller: false,
  },
  {
    _id: "7svf25da-c2ff-7sg2-987e-4b7b28sn6js7",
    title: "Wooden bowl",
    price: {
      discounted: 300,
      original: 1000,
    },
    rating: 2,
    imgURL: woodenBowl,
    categoryGroup: ["Dining"],
    categoryName: "Bowls",
    offer: "70%",
    isBestseller: false,
  },
  {
    _id: "3b799232-cde3-4c22-9248-509b15539547",
    title: "White Brown Planter",
    price: {
      discounted: 1550,
      original: 2325,
    },
    rating: 5,
    imgURL: whiteBrownPlanter,
    categoryGroup: ["Decor"],
    categoryName: "Planter",
    offer: "50%",
    isBestseller: true,
  },
  {
    _id: "9b44b7e1-b94c-4e84-a131-11c608170261",
    title: "Gold Detail Plate",
    price: {
      discounted: 2500,
      original: 3000,
    },
    rating: 1,
    imgURL: whiteGoldPlate,
    categoryGroup: ["Dining"],
    categoryName: "Plates",
    offer: "20%",
    isBestseller: false,
  },
  {
    _id: "0c3f12ae-60ed-4fa9-a968-3210e8ea2399",
    title: "Mini Donut Plate",
    price: {
      discounted: 1000,
      original: 1200,
    },
    rating: 4,
    imgURL: donutPlate,
    categoryGroup: ["Kitchen"],
    categoryName: "Planter",
    offer: "20%",
    isBestseller: false,
  },

  {
    _id: "58027fcf-1854-449b-9607-27ceefe049d1",
    title: "Mini Couple Cups",
    price: {
      discounted: 199,
      original: 999,
    },
    rating: 2,
    imgURL: comboSet2,
    categoryGroup: ["Dining", "Gifts"],
    categoryName: "Cups",
    offer: "combo-offer",
    isBestseller: false,
  },

  {
    _id: "3b799232-cde3-4c22-9245-508b15539547",
    title: "Classic Planter",
    price: {
      discounted: 1359,
      original: 1599,
    },
    rating: 3,
    imgURL: whiteBrownPlanter,
    categoryGroup: ["Gifts"],
    categoryName: "Planter",
    offer: "70%",
    isBestseller: false,
  },
  {
    _id: "9b456541-b94c-4e84-a131-11c608170261",
    title: "Gold Detail Plate",
    price: {
      discounted: 5000,
      original: 6000,
    },
    rating: 5,
    categoryGroup: ["Dining"],
    imgURL: whiteGoldPlate,
    categoryName: "Plates",
    offer: "20%",
    isBestseller: false,
  },
  {
    _id: "0c3f12ae-60ed-4fa9-a968-32133asa2399",
    title: "Black Plate",
    price: {
      discounted: 700,
      original: 840,
    },
    rating: 3,
    imgURL: donutPlate,
    categoryGroup: ["Kitchen", "Gift"],
    categoryName: "Plates",
    offer: "20%",
    isBestseller: true,
  },
  {
    _id: "31d3ae92-47a3-49f3-9c89-d10d4s2d85e2",
    title: "Micheil Set of 1",
    price: {
      discounted: 500,
      original: 650,
    },
    rating: 2,
    imgURL: comboSet3,
    categoryGroup: ["Dining"],
    categoryName: "Plates",
    offer: "30",
    isBestseller: true,
  },
  {
    _id: "eb83msda-a573-4f98-8c39-b572sdjk1fec",
    title: "Dazzo Set of 6 Plates",
    price: {
      discounted: 1350,
      original: 4000,
    },
    rating: 5,
    imgURL: comboSet4,
    categoryGroup: ["Kitchen", "Gifts"],
    categoryName: "Plates",
    offer: "combo-offer",
    isBestseller: true,
  },
  {
    _id: "580a8scf-1854-449b-9607-27ce73bfo5d1",
    title: "Decor Cups",
    price: {
      discounted: 800,
      original: 1500,
    },
    rating: 1,
    imgURL: comboSet2,
    categoryGroup: ["Kitchen", "Decor"],
    categoryName: "Gifts",
    offer: "combo-offer",
    isBestseller: false,
  },
  {
    _id: "5d48s0e3-5467-4012-9d58-59683bf28259",
    title: "Jane Bowls Set of 3",
    price: {
      discounted: 4599,
      original: 5900,
    },
    rating: 5,
    imgURL: fancyBowls,
    categoryGroup: ["Dining", "Gifts"],
    categoryName: "Gifts",
    offer: "combo-offer",
    isBestseller: true,
  },

  {
    _id: "6b7sd8d3-e662-4a56-9d47-cfdab28348299",
    title: "Don't fear Cup",
    price: {
      discounted: 2999,
      original: 5398,
    },
    rating: 3,
    imgURL: fancyCup,
    categoryGroup: ["Kitchen", "Gifts"],
    categoryName: "Gifts",
    offer: "50%",
    isBestseller: false,
  },
  {
    _id: "0balsf7a-285e-4fc4-ad8a-2191asjdmbe02",
    title: "Ecofriendly Planter",
    price: {
      discounted: 249,
      original: 425,
    },
    rating: 1,
    imgURL: jugPlanter,
    categoryGroup: ["Decor", "Gifts"],
    categoryName: "Planters",
    offer: "70%",
    isBestseller: true,
  },
  {
    _id: "4833490d-c2ff-499d-9ab4-4b7b62as9s10d",
    title: "Blue Cup Saucer",
    price: {
      discounted: 1000,
      original: 1700,
    },
    rating: 3,
    imgURL: blueCup,
    categoryGroup: ["Dining", "Gifts"],
    categoryName: "Cups",
    offer: "70%",
    isBestseller: false,
  },
  {
    _id: "3b79as932-cde3-4c42-9248-509b18a39547",
    title: "Clay Planter",
    price: {
      discounted: 500,
      original: 850,
    },
    rating: 4,
    imgURL: whiteBrownPlanter,
    categoryGroup: ["Kitchen"],
    categoryName: "Planter",
    offer: "70%",
    isBestseller: true,
  },
];
